<template>
  <span :class="['control-types', className]" v-if="keys.length > 0">
    <img v-for="(key, index) in keys" :key="index" :src="require(`../assets/img/${key}.png`)" alt="" />
  </span>
</template>

<script>
  import enums from '../utils/enums';
  export default {
    props: {
      materiel: {
        type: Object,
        default() {
          return {};
        },
      },
      className: {
        type: String,
        default: 'control-types',
      },
    },
    data() {
      return {
        warningKeys: enums.controlType,
        keys: [],
      };
    },
    watch: {
      materiel: {
        handler: function (newValue) {
          this.keys = [];
          this.warningKeys.map(key => {
            if (newValue[key]) {
              this.keys.push(key);
            }
          });
        },
        deep: true,
      },
    },
  };
</script>

<style lang="less" scoped>
  .control-types {
    display: inline-block;

    img {
      width: 30px;
      margin-right: 6px;
    }
  }
</style>
